import React, { useEffect, useState } from "react";

const LoadingScreen = (props) => {
  const [progress, setProgress] = useState(1);
  useEffect(() => {
     
    progressBar();

    return ()=>{
      console.log("Loading screen cleanup function executed")
       setProgress(101)
    }

  }, []);

  const progressBar = () => {
    if (progress < 101) {
      for (let i = progress; i < 100; i++) {
        setTimeout(() => {
          setProgress(progress + i);
         
        }, 10 * i);
      }
    }
  };

  const progressBarComp = () => (
    <div style={{zIndex:1000}} className="text-white text-xl p-3">
      <div>
        <div className="text-white flex-col items-center flex justify-center text-xl p-3">
          {props.uploading
            ? progress === 100
              ? "COMPLETED"
              : `UPLOADING... ${progress}%`
            : props.loading
            ? "LOADING >>> "
            : "LOADED"}
        </div>
        <div
          style={{
            width: "50vw",
            boxShadow: "var(--box-shadow)",
            background: "var(--main-bg-dark)",
            margin: "19px 10px",
            
           
          }}
          className="w-full h-7 bg-gray-200 rounded-full dark:bg-gray-700"
        >
          <div
            className="h-7 bg-gray-600 rounded-full dark:bg-gray-300 flex items-center p-2 text-xs"
            style={{
              width: `${progress}%`,
              background: "var(--main-color)",
              boxShadow: "var(--box-shadow-dark)",
            }}
          >
            {progress}%
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      style={{ zIndex: 10000 }}
      className="loading_comp flex flex-col fixed min-w-full h-full z-50 bg-stone-900 justify-center items-center"
    >
      {progressBarComp()}

      {progress >= 99 && props.successMessage && props.successMessage !== "" && (
        <div className="flex items-center justify-center flex-col">
          <div className="bx bx-check-circle p-3 bg-green-600 font-extrabold text-5xl rounded-full"></div>
          <div className="p-3 font-extrabold text-2xl">{props.successMessage}</div>
        </div>
      )}
      {progress >= 99 && props.errorMessage && props.errorMessage !== "" && (
        <div className="flex items-center justify-center flex-col">
          <div className="bx bx-error-circle p-3 bg-red-600 font-extrabold text-5xl rounded-full"></div>
          <div className="p-3 font-extrabold text-2xl">{props.errorMessage}</div>
        </div>
      )}

      <div className="m-2 flex justify-evenly p-4">

      {
        progress >= 99 && props.close && (
          <div
          onClick={props.onClose}
          className="p-3 m-2 mt-5 cursor-pointer hover:bg-red-900 bg-red-700 font-extrabold uppercase rounded text-white text-lg flex items-center"
        >
          close
          <i className="text-2xl bx bx-check px-2"></i>
        </div>
        )
      }
      {progress >= 99 && !props.hideContinue && (!props.errorMessage || props.errorMessage === "") && (
        <div
          onClick={props.reset}
          className="p-3 mt-5 cursor-pointer hover:bg-green-900 bg-green-700 font-extrabold uppercase rounded text-white text-lg flex items-center"
        >
          continue
          <i className="bx bx-arrow-to-right px-2"></i>
        </div>
      )}
      </div>
    </div>
  );
};

export default LoadingScreen;
